import { useEffect, useState } from "react";
import concelloLugoLogo from "@/assets/logo-concello-lugo.png";
import { useLanguage } from "@/contexts/LanguageContext";

const DATE_LOCALES = {
  gl: "gl-ES",
  es: "es-ES",
  en: "en-GB",
} as const;

export const StatusBar = () => {
  const { language } = useLanguage();
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // Actualizar cada minuto
    
    return () => clearInterval(interval);
  }, []);

  const rawDate = new Intl.DateTimeFormat(DATE_LOCALES[language], {
    weekday: "long",
    day: "numeric",
    month: "long",
  }).format(currentTime);
  const formattedDate = rawDate.charAt(0).toUpperCase() + rawDate.slice(1);
  const formattedTime = new Intl.DateTimeFormat(DATE_LOCALES[language], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(currentTime);

  return (
    <div className="status-bar">
      <div className="status-date-group">
        <div className="status-logo-frame">
          <img
            src={concelloLugoLogo}
            alt="Concello de Lugo"
            className="status-logo"
          />
        </div>
        <div className="status-date">{formattedDate}</div>
      </div>
      <div className="status-time">{formattedTime}</div>
    </div>
  );
};
